import DateField from "../bookings/DateField";
import { Input } from "@/components/ui/input";

// Italian date picker + 24h time for a local "YYYY-MM-DDTHH:MM" value (replaces the browser's native datetime-local).
export default function DateTimeField({ value, onChange, testid, defaultTime = "00:00" }) {
  const [date, time] = (value || "").split("T");
  const setTime = (t) => onChange(date ? `${date}T${t}` : "");
  return (
    <div className="flex items-center gap-2">
      <DateField value={date || ""} onChange={(d) => onChange(`${d}T${time || defaultTime}`)} testid={testid} />
      <Input value={time || ""} onChange={(e) => setTime(e.target.value.replace(/[^0-9:]/g, "").slice(0, 5))} placeholder="hh:mm" disabled={!date}
        onBlur={(e) => { if (date && !/^([01]\d|2[0-3]):[0-5]\d$/.test(e.target.value)) setTime(defaultTime); }} className="h-8 w-20 text-xs" inputMode="numeric" data-testid={`${testid}-time`} />
      {value && <button type="button" className="text-[11px] text-slate-500 underline" onClick={() => onChange("")} data-testid={`${testid}-clear`}>rimuovi</button>}
    </div>
  );
}
